import { FC } from 'react';

interface Props {
  color?: string;
  height?: string;
  width?: string;
  title?: string;
  className?: string;
}

const IconClose: FC<Props> = ({
  color = 'var(--color-mpr-charcoal)',
  height = '16',
  width = '18',
  title = 'Settings',
  className = '',
}) => {
  return (
    <svg
      aria-label={title}
      width={width}
      height={height}
      stroke={color}
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.9918 2.28338C6.06714 1.83132 6.45826 1.5 6.91654 1.5H9.07818C9.53647 1.5 9.92758 1.83132 10.0029 2.28338L10.1808 3.35092C10.2328 3.66262 10.4411 3.92226 10.7176 4.0753C10.7794 4.10952 10.8405 4.14486 10.9009 4.18131C11.1717 4.34487 11.5012 4.39572 11.7975 4.28471L12.8115 3.90481C13.2407 3.74404 13.7232 3.91709 13.9523 4.31398L15.0331 6.18601C15.2623 6.5829 15.1709 7.08728 14.8171 7.37855L13.9801 8.06756C13.7364 8.26823 13.6155 8.5781 13.6214 8.89377C13.622 8.9291 13.6224 8.96451 13.6224 9C13.6224 9.03548 13.622 9.07089 13.6214 9.10621C13.6155 9.42189 13.7364 9.73176 13.9801 9.93243L14.8171 10.6214C15.1709 10.9127 15.2623 11.4171 15.0331 11.814L13.9523 13.686C13.7232 14.0829 13.2407 14.256 12.8115 14.0952L11.7975 13.7153C11.5012 13.6043 11.1717 13.6551 10.9009 13.8187C10.8405 13.8551 10.7794 13.8905 10.7176 13.9247C10.4411 14.0777 10.2328 14.3374 10.1808 14.6491L10.0029 15.7166C9.92758 16.1687 9.53647 16.5 9.07818 16.5H6.91654C6.45826 16.5 6.06714 16.1687 5.9918 15.7166L5.81388 14.6491C5.76192 14.3374 5.55361 14.0777 5.27714 13.9247C5.21533 13.8905 5.15423 13.8551 5.09387 13.8187C4.82301 13.6551 4.49356 13.6043 4.19726 13.7153L3.1832 14.0952C2.75405 14.256 2.27155 14.0829 2.04241 13.686L0.961591 11.814C0.732448 11.4171 0.823826 10.9127 1.17764 10.6215L2.0146 9.93244C2.25836 9.73177 2.37919 9.4219 2.37334 9.10623C2.37269 9.0709 2.37236 9.03549 2.37236 9C2.37236 8.96452 2.37269 8.92911 2.37334 8.89379C2.37919 8.57811 2.25836 8.26824 2.0146 8.06758L1.17764 7.37856C0.823825 7.08729 0.732447 6.58291 0.961591 6.18602L2.04241 4.31399C2.27155 3.9171 2.75405 3.74405 3.1832 3.90483L4.19725 4.28472C4.49355 4.39573 4.823 4.34487 5.09386 4.18132C5.15422 4.14487 5.21532 4.10952 5.27714 4.0753C5.55361 3.92226 5.76192 3.66262 5.81387 3.35092L5.9918 2.28338Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4972 8.99993C10.4972 10.3806 9.37788 11.4999 7.99717 11.4999C6.61646 11.4999 5.49717 10.3806 5.49717 8.99993C5.49717 7.61922 6.61646 6.49993 7.99717 6.49993C9.37788 6.49993 10.4972 7.61922 10.4972 8.99993Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <title>{title}</title>
    </svg>
  );
};

export default IconClose;
